import {
  AutocompleteArrayInput,
  AutocompleteInput,
  Create,
  DateInput,
  ReferenceArrayInput,
  ReferenceInput,
  required,
  SimpleForm,
  useNotify,
  useRedirect,
  useRefresh
} from "react-admin";
import {ProfileEnum} from "../../utils/general-profile.enum";
import React, {useMemo} from "react";
import {CustomToolbar} from "./component/toolbar.component";

const FormsAvailabilityCreate = (props) => {

   const redirect = useRedirect()
   const notify = useNotify()
   const refresh = useRefresh()

   const onSuccess = ({ data }) => {
      notify('Fomulário criado com sucesso')
      redirect('/formsAvailability', undefined, {}, {}, { data })
      refresh()
   }


  const profilesAvailable = useMemo(() => {
    return [
      ProfileEnum.ADMIN,
      ProfileEnum.GENERAL_PRINCIPAL,
      ProfileEnum.NPJ_LAWYER,
      ProfileEnum.SECRETARY,
      ProfileEnum.PRINCIPAL,
      ProfileEnum.LAWYER,
    ].map(item => `'${item}'`)
  }, [])

   return (
      <Create
        {...props}
        onSuccess={onSuccess}
      >
         <SimpleForm  toolbar={<CustomToolbar />} actions={<CustomToolbar />} >
            <ReferenceInput
               perPage={100000}
               label="Formulário"
               source="formId"
               reference="forms"
               sort={{}}
               fullWidth
               validate={[required()]}
            >
               <AutocompleteInput
                  optionText="name"
                  optionValue="id"
               />
            </ReferenceInput>
            <ReferenceArrayInput

               sort={{ field: "name", order: "ASC" }}
               perPage={10000}
               filter={{ academic_period: 'current' }}
               label="Turma"
               source="classes"
               multiple
               reference="classes"
               fullWidth
               validate={[required()]}
            >
               <AutocompleteArrayInput
                 filterToQuery={searchText => ({ name: searchText })}
                 source={'name'} optionText={'name'} optionValue={'id'} multiple />
            </ReferenceArrayInput >
            <ReferenceArrayInput
               perPage={100000}
               label="Responsáveis Pela Aprovação (Deixar nulo para que todos possam deferir / indeferir requisições)"
               source="owners"
               reference="users"
               filter={{ profiles: profilesAvailable }}
               allowNull
               fullWidth
            >
               <AutocompleteArrayInput
                  optionText="name"
                  optionValue="id"
               />
            </ReferenceArrayInput>
            <DateInput source="start" label={'Inicio Disponibilidade'} fullWidth validate={[required()]} />
            <DateInput source="end" label={'Fim Disponibilidade'} fullWidth validate={[required()]} />
         </SimpleForm>
      </Create >
   )
}




export default FormsAvailabilityCreate;
